import { SweetAlertOptions } from "sweetalert2";

export class SwalConfs {
    private static baseSwalConf: SweetAlertOptions = { 
            toast: true, 
            position: 'bottom-right', 
            iconColor: 'white',
            customClass : {
                popup: 'colored-toast'
            },
            timer: 5000,
            timerProgressBar: false,
            showConfirmButton: false,
        };

    static getErrorToast(title?: string, text?: string): SweetAlertOptions {
        return { 
            ...this.baseSwalConf,
            title: title, 
            icon: 'error', 
            text: text,
        };
    }

    static getSuccessToast(title?: string, text?: string, timeout = 5000): SweetAlertOptions {
        return { 
            ...this.baseSwalConf,
            title: title, 
            icon: 'success', 
            text: text,
        };
    }
}